import { getOutstandingBankstatement } from "../commonUtil";
import { downloadWorkbook } from "./excelBrowser";

const collectionregistercolumnsToDownload = [
  "Policy Number",
  "Collection Date",
  "Insured Name / Recieved From",
  "Cheque No/ Credit Card No",
  "Debit Amount",
];
const BankStatementsColumnsToDownload = [
  "Date",
  "Remarks",
  "Withdrawals",
  "Deposits",
  "Balance",
];

function downloadOutputData(outputData: any) {
  const outstandingChequeworkSheetData = createSheetData(
    outputData.outstandingCheques,
    collectionregistercolumnsToDownload
  );
  const clearedChequeworkSheetData = createSheetData(
    outputData.matchedChequeInBankStatements,
    collectionregistercolumnsToDownload
  );
  const clearedChequePreviousMonthWorkSheetData =
    outputData.previousMonthClearedCheques
      ? createSheetData(
          outputData.previousMonthClearedCheques || [],
          collectionregistercolumnsToDownload
        )
      : [];
  const outstandingBCAWorkSheetData = createSheetData(
    outputData.outstandingBCA,
    collectionregistercolumnsToDownload
  );
  const clearedBCAWorkSheetData = createSheetData(
    outputData.bankCreditAdviceFoundInBankStatements,
    collectionregistercolumnsToDownload
  );
  const outstandingBankstatements = getOutstandingBankstatement(
    outputData.bankStatements
  );
  const outstandingBankStatementSheetData = createSheetData(
    outstandingBankstatements,
    BankStatementsColumnsToDownload
  );

  downloadExcel({
    workSheets: [
      {
        workSheetData: outstandingChequeworkSheetData,
        worksheetName: "Oustanding Cheques",
      },
      {
        workSheetData: clearedChequeworkSheetData,
        worksheetName: "Cleared Cheques",
      },
      {
        workSheetData: clearedChequePreviousMonthWorkSheetData,
        worksheetName: "Previous Month Cleared Cheques",
      },
      {
        workSheetData: outstandingBCAWorkSheetData,
        worksheetName: "Oustanding Bank Credit Advice",
      },
      {
        workSheetData: clearedBCAWorkSheetData,
        worksheetName: "Cleared Bank Credit Advice",
      },
      {
        workSheetData: outstandingBankStatementSheetData,
        worksheetName: "Outstanding Bank Statements",
      },
    ],

    fileName: `Output Data ${new Date().toDateString()}`,
  });
}

export async function downloadExcel(params: {
  workSheets: {
    workSheetData: any[];
    worksheetName: string;
  }[];
  fileName: string;
}) {
  const { fileName, workSheets } = params;
  const filename = fileName ?? `Output data ${new Date().toDateString()}`;

  await downloadWorkbook({
    fileName: filename,
    workSheets: workSheets.map(({ worksheetName, workSheetData }) => ({
      worksheetName,
      workSheetData,
    })),
  });
}

export function createSheetData(data: any[], columnsToDownload: string[]) {
  const dataWithNeededColumns = data.map((datum) => {
    const datumToDownload: any = {};
    columnsToDownload.forEach((columnName) => {
      datumToDownload[columnName] = datum[columnName];
    });
    return datumToDownload;
  });
  const headerData = Object.keys(dataWithNeededColumns[0]);
  const dataRows = dataWithNeededColumns.map((obj: any) => {
    return Object.values(obj);
  });
  const workSheetData: any[] = [headerData, ...dataRows];
  console.log({ testDa: workSheetData });
  return workSheetData;
}

export { downloadOutputData };
